module.exports = __webpack_public_path__ + "static/media/4ODA3.2060c2e1.jpg";